'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mobxReact = require('mobx-react');

var _ContactDetail = require('../page-contacts/ContactDetail');

var _ContactDetail2 = _interopRequireDefault(_ContactDetail);

var _common = require('../common');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;
var PeopleDetailPage = (_dec = (0, _mobxReact.inject)('Clients'), _dec2 = (0, _common.loaderDecorator)({
  actions: function actions(props) {
    var Clients = props.Clients,
        id = props.params.id;

    return {
      organizations: { method: Clients.relationships.list, params: { params: { second_party: id } } },
      person: { method: Clients.people.retrieve, params: id }
    };
  },
  className: 'page-loader',
  logo: true,
  Wrapper: function Wrapper(data) {
    return (// eslint-disable-line react/display-name
      _react2.default.createElement(
        _common.Page,
        { name: 'contact', type: 'detail' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Contact - ' + getNameOrDefault(data.person) }),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          data.children
        )
      )
    );
  } }), _dec(_class = _dec2(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(PeopleDetailPage, _Component);

  function PeopleDetailPage() {
    _classCallCheck(this, PeopleDetailPage);

    return _possibleConstructorReturn(this, (PeopleDetailPage.__proto__ || Object.getPrototypeOf(PeopleDetailPage)).apply(this, arguments));
  }

  _createClass(PeopleDetailPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_ContactDetail2.default, {
        contact: this.props.person,
        organizations: (0, _get3.default)(this.props.organizations, 'results', [])
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PeopleDetailPage;
}(_react.Component), _class2.propTypes = {
  organizations: _propTypes2.default.object,
  person: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = PeopleDetailPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/pages/PeopleDetailPage.js');
  reactHotLoader.register(PeopleDetailPage, 'PeopleDetailPage', '/app/src/components/pages/PeopleDetailPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/pages/PeopleDetailPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2VzL1Blb3BsZURldGFpbFBhZ2UuanMiXSwibmFtZXMiOlsiZ2V0TmFtZU9yRGVmYXVsdCIsIkZvcm1hdHRpbmdVdGlscyIsIlBlb3BsZURldGFpbFBhZ2UiLCJhY3Rpb25zIiwicHJvcHMiLCJDbGllbnRzIiwiaWQiLCJwYXJhbXMiLCJvcmdhbml6YXRpb25zIiwibWV0aG9kIiwicmVsYXRpb25zaGlwcyIsImxpc3QiLCJzZWNvbmRfcGFydHkiLCJwZXJzb24iLCJwZW9wbGUiLCJyZXRyaWV2ZSIsImNsYXNzTmFtZSIsImxvZ28iLCJXcmFwcGVyIiwiZGF0YSIsImNoaWxkcmVuIiwib2JzZXJ2ZXIiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJvYmplY3QiLCJpc1JlcXVpcmVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOztBQUdBOzs7O0FBQ0E7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFDUUEsZ0IsR0FBcUJDLHNCLENBQXJCRCxnQjtJQXVCRkUsZ0IsV0FyQkwsdUJBQU8sU0FBUCxDLFVBQ0EsNkJBQWdCO0FBQ2ZDLFdBQVMsaUJBQUNDLEtBQUQsRUFBVztBQUFBLFFBQ1ZDLE9BRFUsR0FDa0JELEtBRGxCLENBQ1ZDLE9BRFU7QUFBQSxRQUNTQyxFQURULEdBQ2tCRixLQURsQixDQUNERyxNQURDLENBQ1NELEVBRFQ7O0FBRWxCLFdBQU87QUFDTEUscUJBQWUsRUFBQ0MsUUFBUUosUUFBUUssYUFBUixDQUFzQkMsSUFBL0IsRUFBcUNKLFFBQVEsRUFBQ0EsUUFBUSxFQUFDSyxjQUFjTixFQUFmLEVBQVQsRUFBN0MsRUFEVjtBQUVMTyxjQUFRLEVBQUNKLFFBQVFKLFFBQVFTLE1BQVIsQ0FBZUMsUUFBeEIsRUFBa0NSLFFBQVFELEVBQTFDO0FBRkgsS0FBUDtBQUlELEdBUGM7QUFRZlUsYUFBVyxhQVJJO0FBU2ZDLFFBQU0sSUFUUztBQVVmQyxXQUFTLGlCQUFDQyxJQUFEO0FBQUEsV0FBWTtBQUNuQjtBQUFDLG9CQUFEO0FBQUEsVUFBTSxNQUFLLFNBQVgsRUFBcUIsTUFBSyxRQUExQjtBQUNFLHNDQUFDLHFCQUFELElBQVEsc0JBQW9CbkIsaUJBQWlCbUIsS0FBS04sTUFBdEIsQ0FBNUIsR0FERjtBQUVFO0FBQUMsc0JBQUQsQ0FBTSxPQUFOO0FBQUE7QUFDR00sZUFBS0M7QUFEUjtBQUZGO0FBRE87QUFBQSxHQVZNLEVBQWhCLEMsbUNBbUJBQyxtQjs7Ozs7Ozs7Ozs7NkJBRVc7QUFDUixhQUNFLDhCQUFDLHVCQUFEO0FBQ0UsaUJBQVMsS0FBS2pCLEtBQUwsQ0FBV1MsTUFEdEI7QUFFRSx1QkFBZSxtQkFBSSxLQUFLVCxLQUFMLENBQVdJLGFBQWYsRUFBOEIsU0FBOUIsRUFBeUMsRUFBekM7QUFGakIsUUFERjtBQU1EOzs7Ozs7Ozs7OztFQVI0QmMsZ0IsV0FVdEJDLFMsR0FBWTtBQUNqQmYsaUJBQWVnQixvQkFBVUMsTUFEUjtBQUVqQlosVUFBUVcsb0JBQVVDLE1BQVYsQ0FBaUJDO0FBRlIsQztlQU1OeEIsZ0I7Ozs7Ozs7Ozs7OzBCQXZDUEYsZ0I7MEJBdUJGRSxnQiIsImZpbGUiOiJQZW9wbGVEZXRhaWxQYWdlLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBIZWxtZXQgZnJvbSAncmVhY3QtaGVsbWV0JztcbmltcG9ydCB7IG9ic2VydmVyLCBpbmplY3QgfSBmcm9tICdtb2J4LXJlYWN0JztcbmltcG9ydCB7IGdldCB9IGZyb20gJ2xvZGFzaCc7XG5cbmltcG9ydCBDb250YWN0RGV0YWlsIGZyb20gJy4uL3BhZ2UtY29udGFjdHMvQ29udGFjdERldGFpbCc7XG5pbXBvcnQgeyBQYWdlLCBsb2FkZXJEZWNvcmF0b3IgfSBmcm9tICcuLi9jb21tb24nO1xuXG5pbXBvcnQgeyBGb3JtYXR0aW5nVXRpbHMgfSBmcm9tICcuLi8uLi91dGlscyc7XG5jb25zdCB7IGdldE5hbWVPckRlZmF1bHQgfSA9IEZvcm1hdHRpbmdVdGlscztcblxuQGluamVjdCgnQ2xpZW50cycpXG5AbG9hZGVyRGVjb3JhdG9yKHtcbiAgYWN0aW9uczogKHByb3BzKSA9PiB7XG4gICAgY29uc3QgeyBDbGllbnRzLCBwYXJhbXM6IHsgaWQgfSB9ID0gcHJvcHM7XG4gICAgcmV0dXJuIHtcbiAgICAgIG9yZ2FuaXphdGlvbnM6IHttZXRob2Q6IENsaWVudHMucmVsYXRpb25zaGlwcy5saXN0LCBwYXJhbXM6IHtwYXJhbXM6IHtzZWNvbmRfcGFydHk6IGlkfX19LFxuICAgICAgcGVyc29uOiB7bWV0aG9kOiBDbGllbnRzLnBlb3BsZS5yZXRyaWV2ZSwgcGFyYW1zOiBpZH0sXG4gICAgfTtcbiAgfSxcbiAgY2xhc3NOYW1lOiAncGFnZS1sb2FkZXInLFxuICBsb2dvOiB0cnVlLFxuICBXcmFwcGVyOiAoZGF0YSkgPT4gKCAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIHJlYWN0L2Rpc3BsYXktbmFtZVxuICAgIDxQYWdlIG5hbWU9J2NvbnRhY3QnIHR5cGU9J2RldGFpbCc+XG4gICAgICA8SGVsbWV0IHRpdGxlPXtgQ29udGFjdCAtICR7Z2V0TmFtZU9yRGVmYXVsdChkYXRhLnBlcnNvbil9YH0gLz5cbiAgICAgIDxQYWdlLkNvbnRlbnQ+XG4gICAgICAgIHtkYXRhLmNoaWxkcmVufVxuICAgICAgPC9QYWdlLkNvbnRlbnQ+XG4gICAgPC9QYWdlPlxuICApfVxuKVxuQG9ic2VydmVyXG5jbGFzcyBQZW9wbGVEZXRhaWxQYWdlIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgcmVuZGVyICgpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPENvbnRhY3REZXRhaWxcbiAgICAgICAgY29udGFjdD17dGhpcy5wcm9wcy5wZXJzb259XG4gICAgICAgIG9yZ2FuaXphdGlvbnM9e2dldCh0aGlzLnByb3BzLm9yZ2FuaXphdGlvbnMsICdyZXN1bHRzJywgW10pfVxuICAgICAgLz5cbiAgICApO1xuICB9XG5cbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICBvcmdhbml6YXRpb25zOiBQcm9wVHlwZXMub2JqZWN0LFxuICAgIHBlcnNvbjogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IFBlb3BsZURldGFpbFBhZ2U7XG4iXX0=